export default __webpack_public_path__ + "static/media/close4.334743d5.svg";